export const REFRESH_TRUSTED_CONTACTS_TABLE_AIS = 'REFRESH_TRUSTED_CONTACTS_TABLE_AIS';
export const SET_TRUSTED_CONTACTS_AIS_REFRESH_FN = 'SET_TRUSTED_CONTACTS_AIS_REFRESH_FN';
